import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import routes from "@/lib/routes";
import styles from "@/styles/Header.module.scss";
import classnames from "classnames";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var LogoSPOOX = dynamic(function () {
  return import("../../svgs/logo_spoox.svg");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../svgs/logo_spoox.svg")];
    }
  }
});
var LogoSPOOXEX = dynamic(function () {
  return import("../../svgs/logo_spoox_ex.svg");
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../svgs/logo_spoox_ex.svg")];
    }
  }
});

function HeaderLogo(_ref) {
  var adultMode = _ref.adultMode,
      noTransition = _ref.noTransition;
  var router = useRouter();
  var href = noTransition ? "#" : routes.home;
  var handleClick = useCallback(function (e) {
    if (noTransition) {
      e.preventDefault();
      return false;
    }
  }, [noTransition]);
  var headerPageReload = router.asPath.includes(routes.restricted) && adultMode;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.logoWrapper, _defineProperty({}, styles.adultMode, adultMode)),
    children: [!headerPageReload && /*#__PURE__*/_jsx(Link, {
      href: href,
      children: /*#__PURE__*/_jsxs("a", {
        onClick: handleClick,
        children: [!adultMode && /*#__PURE__*/_jsx(LogoSPOOX, {
          className: styles.logoSVG
        }), adultMode && /*#__PURE__*/_jsx(LogoSPOOXEX, {
          className: styles.logoSVG
        })]
      })
    }), headerPageReload && /*#__PURE__*/_jsx("a", {
      href: href,
      children: adultMode && /*#__PURE__*/_jsx(LogoSPOOXEX, {
        className: styles.logoSVG
      })
    })]
  });
}

export default /*#__PURE__*/memo(HeaderLogo);